module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_foodservice_sp-aa3915f4102f3831760f8058b818352b.svg";